// Initialize form ID
let form_id = document.getElementById('form_id')?.value || '';
const show = document.getElementById('filtered-products')?.dataset?.show;
const template = document.getElementById('filtered-products')?.dataset?.template;
const match = document.getElementById('filtered-products')?.dataset?.match;
class DropdownManager {
  constructor() {
    // Only initialize if there are custom dropdowns on the page
    if (document.querySelectorAll('.custom-dropdown').length === 0) {
      return; // Exit early if no dropdowns found
    }
    
    this.initializeDropdowns();
    this.addGlobalClickHandler();
  }

  closeAllDropdowns() {
    document.querySelectorAll('.dropdown-options.active').forEach(optionList => {
      optionList.classList.remove('active');
    });
  }

  handleOptionSelect(option, toggleButton, dropdownID, optionsList) {
    const img = option.querySelector('img');
    toggleButton.innerHTML = option.innerHTML;
    toggleButton.dataset.value = option.dataset.value;

    const skuElement = document.getElementById(`sku_${dropdownID}`);
    if (skuElement) {
      skuElement.textContent = `-${option.dataset.value}`;
    }
    
    const vbElement = document.querySelector(`.${dropdownID}_vb`);
    if (vbElement && img) {
      vbElement.innerHTML = `<div class="label_name">${dropdownID}</div> <img alt="${dropdownID}" src="${img.src || ''}" alt="${img.alt || ''}" /> 
      <div class="option_name">${img.alt || ''}</div>`;
    } else if (vbElement) {
      vbElement.innerHTML = `<div class="label_name">${dropdownID}</div>`;
    }

    optionsList.classList.remove('active');
  }

  initializeDropdowns() {
    document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
      const dropdownID = dropdown.getAttribute('data-dropdown');
      const toggleButton = dropdown.querySelector('.dropdown-toggle');
      const optionsList = document.querySelector(`.dropdown-options[data-dropdown="${dropdownID}"]`);
      
      // Skip if required elements are missing
      if (!toggleButton || !optionsList) return;

      // Handle toggle button click
      toggleButton.addEventListener('click', (event) => {
        event.stopPropagation();
        this.closeAllDropdowns();
        optionsList.classList.toggle('active');
      });

      // Handle option selection
      optionsList.querySelectorAll('li').forEach(option => {
        option.addEventListener('click', () =>
          this.handleOptionSelect(option, toggleButton, dropdownID, optionsList)
        );
      });

      // Set initial default option
      const firstOption = optionsList.querySelector('li');
      if (firstOption) {
        try {
          this.handleOptionSelect(firstOption, toggleButton, dropdownID, optionsList);
        } catch (error) {
          console.warn(`Error initializing dropdown ${dropdownID}:`, error);
        }
      }
    });
  }

  addGlobalClickHandler() {
    document.addEventListener('click', () => {
      this.closeAllDropdowns();
    });
  }
}

// Add this helper function near the top of the file, after the class DropdownManager
function updateSkuElement(typeName, action, value = '') {
  const skuElement = document.querySelector(`#sku_${typeName}`);
  if (!skuElement) return;
  
  switch(action) {
    case 'hide':
      skuElement.classList.add('none_h');
      skuElement.innerHTML = '';
      break;
    case 'show':
      skuElement.classList.remove('none_h');
      break;
    case 'update':
      skuElement.innerHTML = value;
      break;
  }
}

function handleSlideButtonClicks() {
  // First, remove any existing click handlers to prevent duplicates
  document.querySelectorAll(".product_variants .slide_btn").forEach(button => {
    // Clone and replace to remove all event listeners
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
  });

  // Then add fresh event listeners
  document.querySelectorAll(".product_variants .slide_btn").forEach(legend => {
    legend.addEventListener("click", function (event) {
      // Stop event propagation to prevent any parent handlers from firing
      event.stopPropagation();

      const fieldset = this.parentElement;

      // Force toggle by checking current state
      if (fieldset.classList.contains("active")) {
        fieldset.classList.remove("active");
      } else {
        fieldset.classList.add("active");
      }

      // Log the state after toggle
    });
  });

}

if (show === 'mount_style') {
  // Update variant details in UI
  function updateVariantDetails(variant, panelElement) {
    console.log(`panelElement: ${panelElement.dataset.dropdown}`);
    // Update featured image
    document.querySelector('#featured_image').src = variant.mount_style_image;
    console.log(`variant.panel?.length: ${variant.panel?.length}`);
    // Process panel data
    if (variant.panel?.length == 0) {
      document.querySelector(`.custom-dropdown[data-dropdown="${panelElement.dataset.dropdown}"]`).parentElement.classList.add('none_h');
    } else {
      document.querySelector(`.custom-dropdown[data-dropdown="${panelElement.dataset.dropdown}"]`).parentElement.classList.remove('none_h');
    }
    if (variant.panel?.length) {
      const panel_vb = document.querySelector('.Panel_vb');
      panel_vb.innerHTML = "";
      variant.panel.forEach((panel, index) => {
        if (panel) {
          const li = document.createElement('li');
          li.setAttribute('data-value', panel.value);
          li.innerHTML = `<label><input type="radio" form='${form_id}' ${index === 0 ? 'checked' : ''} 
            name='properties[${panelElement.dataset.dropdown}]' value="${panel.name}">
            <img src="${panel.image || '#'}&width=100" 
                alt="${panel.name || 'Image'}" width='100'> ${panel.name}</label>`;
          panelElement.appendChild(li);
          if (index == 0) {
            panel_vb.innerHTML = `<div class="label_name">Panel</div> <img src="${panel.image || '#'}&width=70" 
                alt="${panel.name || 'Image'}" width='70px'><div class="option_name"> ${panel.name}</div>`;
          }
        }
      });
    }
    new DropdownManager();
    // Build specifications HTML
    const specs = ['height', 'width_dia', 'length', 'extension', 'top_to_outlet', 'chain', 'canopy']
      .reduce((acc, key) => {
        return variant[key] ? acc + `<span><strong>${key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}:</strong> ${variant[key]}</span>` : acc;
      }, '');

    document.querySelector('#Specs').innerHTML = specs;
    document.querySelector('.mount_slected').innerHTML = variant.mount_style;

    // Update spec sheet and SKU
    document.querySelector('#CCS').href = variant.spec_sheet;
    const skuItemId = document.querySelector('#sku_item_id');
    if (skuItemId) {
      skuItemId.innerHTML = variant.item_id;
    }
  }
  // Filter and display size options
  function filterSizes() {
    const checkedStyleInput = document.querySelector('.mount-style-main input:checked');
    if (!checkedStyleInput) return;

    const selectedMountStyle = checkedStyleInput.value.trim().toLowerCase();
    const filteredSizes = variant_json.filter(variant =>
      variant.mount_style?.trim().toLowerCase() === selectedMountStyle && variant.size
    );

    const sizeContainer = document.getElementById('filtered-sizes');
    sizeContainer.innerHTML = '';
    const size_vb = document.querySelector('.size_vb');
    const size_slected = document.querySelector('.size_slected');
    size_slected.innerHTML = '';
    size_vb.innerHTML = '';

    if (filteredSizes.length) {
      const uniqueSizes = new Set();

      filteredSizes.forEach(variant => {
        if (!uniqueSizes.has(variant.size)) {
          uniqueSizes.add(variant.size);

          const sizeElement = document.createElement('div');
          sizeElement.className = 'horizontal-view';
          sizeElement.innerHTML = `
            <input type='radio' class='size_dynamic_' id='size-${variant.item_id}'
              data-mount-style='${variant.mount_style}' form='${form_id}'  
              name='properties[Size]' value='${variant.size}'/>
            <label for='size-${variant.item_id}'>
              <img src="${variant.size_image || '#'}&width=200" 
                alt="${variant.mount_style || 'Image'}" width="50px">
              ${variant.size}
            </label>`;
          sizeContainer.appendChild(sizeElement);
        }
      });

      const firstInput = sizeContainer.querySelector('input[type="radio"]');
      if (firstInput) {
        firstInput.checked = true;
        size_vb.innerHTML = `<strong>Size:</strong> ${firstInput.value}`;
        size_slected.innerHTML = `${firstInput.value}`;
        filterVariantOptions();
      }
      if (sizeContainer.children.length <= 1) {
        sizeContainer.parentElement.classList.add("none_h");
      } else {
        sizeContainer.parentElement.classList.remove("none_h");
      }
    } else {
      sizeContainer.innerHTML = '<p>No sizes found.</p>';
    }
  }
  // Filter and display variant options
  function filterVariantOptions() {
    const checkedSizeInput = document.querySelector('#filtered-sizes input:checked');
    const checkedStyleInput = document.querySelector('.mount-style-main input:checked');

    const size_slected = document.querySelector('.size_slected');
    size_slected.innerHTML = '';
    const product_slected = document.querySelectorAll('.product_slected');
    product_slected.forEach(element => element.innerHTML = '');
    const size_vb = document.querySelector('.size_vb');
    size_vb.innerHTML = '';

    if (!checkedSizeInput || !checkedStyleInput) return;

    size_vb.innerHTML = `<strong>Size:</strong> ${checkedSizeInput.value}`;
    size_slected.innerHTML = `${checkedSizeInput.value}`;

    const selectedSize = checkedSizeInput.value.trim().toLowerCase();
    const selectedMountStyle = checkedStyleInput.value.trim().toLowerCase();

    const filteredVariants = variant_json.filter(variant =>
      variant.size?.trim().toLowerCase() === selectedSize &&
      variant.mount_style?.trim().toLowerCase() === selectedMountStyle &&
      variant.item_id
    );

    const variantContainer = document.getElementById('filtered-variant_options');
    const panelElement = document.querySelector('#panels');
    variantContainer.innerHTML = '';
    panelElement.innerHTML = '';

    if (filteredVariants.length) {
      const uniqueVariants = new Set();

      filteredVariants.forEach(variant => {
        if (!uniqueVariants.has(variant.item_id)) {
          uniqueVariants.add(variant.item_id);

          const optionElement = document.createElement('div');
          optionElement.className = 'horizontal-view';
          optionElement.innerHTML = `
            <input type='radio' class='variant_option_dynamic' id='variant_option-${variant.item_id}'
              data-size='${variant.size}' name='properties[Product Option ID]' 
              form='${form_id}' value='${variant.item_id}'/>
            <label for='variant_option-${variant.item_id}'>
              <img src="${variant.mount_style_image || '#'}&width=200" 
                alt="${variant.mount_style || 'Image'}" width="50px">
              ${variant.item_id}
            </label>`;

          optionElement.querySelector('input').addEventListener('change', () => {
            panelElement.innerHTML = '';
            // Get fresh reference to product_slected elements inside the event listener
            const product_slected = document.querySelectorAll('.product_slected');
            product_slected.forEach(element =>{ 
              element.innerHTML = optionElement.querySelector("input").value;
              console.log(element.innerHTML);
            });
            updateVariantDetails(variant, panelElement);
            filterLampingOptions();
          });

          variantContainer.appendChild(optionElement);
        }
      });

      const firstInput = variantContainer.querySelector('input[type="radio"]');
      if (firstInput) {
        firstInput.checked = true;
        product_slected.forEach(element => element.innerHTML = firstInput.value);
        const selectedVariant = variant_json.find(v => v.item_id === firstInput.value);
        if (selectedVariant) {
          updateVariantDetails(selectedVariant, panelElement);
          filterLampingOptions();
        }
      }
    } else {
      variantContainer.innerHTML = '<p>No variant options found.</p>';
    }
  }

  // Filter and display lamping options
  function filterLampingOptions() {
    const inputs = {
      mountStyle: document.querySelector('.mount-style-main input:checked'),
      size: document.querySelector('#filtered-sizes input:checked'),
      variantOption: document.querySelector('#filtered-variant_options input:checked')
    };


    if (!Object.values(inputs).every(Boolean)) return;

    const selected = {
      mountStyle: inputs.mountStyle.value.trim().toLowerCase(),
      size: inputs.size.value.trim().toLowerCase(),
      variantOption: inputs.variantOption.value.trim().toLowerCase()
    };

    const filteredLamping = variant_json.filter(variant =>
      variant.mount_style?.trim().toLowerCase() === selected.mountStyle &&
      variant.size?.trim().toLowerCase() === selected.size &&
      variant.item_id?.trim().toLowerCase() === selected.variantOption &&
      variant.lamping_type
    );

    const lampingContainer = document.getElementById('filtered-laming_type');
    lampingContainer.innerHTML = '';
    const lamping_vb = document.querySelector('.lamping_vb');
    lamping_vb.innerHTML = '';
    const dropdown_toggle = document.querySelector('.dropdown-toggle');
    dropdown_toggle.innerHTML = '';

    if (filteredLamping.length && filteredLamping[0].lamping_type) {
      filteredLamping[0].lamping_type.forEach((lamping, index) => {
        const lampingElement = document.createElement('li');
        lampingElement.setAttribute('data-value', lamping.value);
        lampingElement.innerHTML = `
          <label for="lamping-${lamping.value}">
            <input type="radio" class="lamping_option" form='${form_id}' 
              name="properties[Lamping]" id="lamping-${lamping.value}"
              data-lamping-name="${lamping.name}" data-item_id="${filteredLamping[0].item_id}" 
              value="${lamping.value}" ${index === 0 ? 'checked' : ''} />
              <img src="${lamping.image}" alt="${lamping.build_box_name || lamping.name}" width="100" height="100">
            ${lamping.name}
          </label>`;
        lampingElement.addEventListener('click', (event) => {
          document.querySelectorAll('#filtered-laming_type label').forEach(label => label.classList.remove('checked_h'));
          event.target.closest('label').classList.add("checked_h");
          filterKelvinOptions(lamping.kelvin_call_out);
          document.querySelector('#skulmping_type').innerHTML = "-[" + lamping.value + "]";
          lamping_vb.innerHTML = `<div class="label_name">Lamping</div> 
          <img src="${lamping.image}" alt="${lamping.build_box_name || lamping.name}" width="100" height="100">
          <div class="option_name_abbrivation"> ${lamping.build_box_name || lamping.name}</div>`;
          dropdown_toggle.innerHTML = lampingElement.innerHTML;
          setTimeout(() => {
            document.querySelector('#filtered-laming_type').classList.remove("active");
          }, 50);
        });

        lampingContainer.appendChild(lampingElement);

        // Automatically trigger filtering for the first lamping option
        const firstInput = lampingContainer.querySelector('input[type="radio"]');
        const firstlabel = lampingContainer.querySelector('label');
        const firstimg = lampingContainer.querySelector('label img');
        if (index === 0) {
          dropdown_toggle.innerHTML = lampingContainer.querySelector("li").innerHTML;
          firstInput.checked = true;
          firstlabel.classList.add("checked_h");
          lamping_vb.innerHTML = `<div class="label_name">Lamping</div>
          <img src="${firstimg.src}" alt="${firstimg.alt}" width="70px">
          <div class="option_name">${firstimg.alt}</div>`;
          const selectedVariant = variant_json.find(v => v.item_id === firstInput.dataset.item_id);
          if (selectedVariant) {
            filterKelvinOptions(selectedVariant.lamping_type[0].kelvin_call_out);
            document.querySelector('#skulmping_type').innerHTML =
              "-[" + selectedVariant.lamping_type[0].value + "]";
          }
        }
      });
    } else {
      lampingContainer.innerHTML = '<p>No lamping options found.</p>';
    }
  }

  // Filter and display Kelvin options
  function filterKelvinOptions(kelvinCallOutArray) {
    const kelvinContainer = document.getElementById('filtered-kelvin-options');
    kelvinContainer.innerHTML = '';
    const kelvin_vb = document.querySelector('.kelvin_vb');
    kelvin_vb.innerHTML = '';
    const kelvin_slected = document.querySelector('.kelvin_slected');
    kelvin_slected.innerHTML = '';
    const optics_vb = document.querySelector('.optics_vb');
    optics_vb.innerHTML = '';

    if (!kelvinCallOutArray?.length) {
      const elements = {
        skuLedType: document.querySelector('#sku_led_type'),
        skuOptics: document.querySelector('#sku_optics')
      };

      Object.values(elements).forEach(el => {
        if (el) el.style.display = 'none';
      });
      document.querySelector('.optics_main').classList.add('none_h');
      document.querySelector('.kelvin_main').classList.add('none_h');
      document.querySelector('#sku_led_type_RLED').innerHTML = '';
      document.getElementById('filtered-optics-options').innerHTML = '';
      return;
    }
    document.querySelector('.kelvin_main').classList.remove('none_h');
    document.querySelector('.optics_main').classList.remove('none_h');

    // Show relevant elements
    const elements = {
      skuLedType: document.querySelector('#sku_led_type'),
      skuOptics: document.querySelector('#sku_optics')
    };

    Object.values(elements).forEach(el => {
      if (el) el.style.display = 'inline-block';
    });

    document.querySelector('#sku_led_type_RLED').innerHTML = '[RLED]';

    kelvinCallOutArray.forEach((kelvin, index) => {
      if (kelvin.kelvin_name && kelvin.optics) {
        const kelvinDiv = document.createElement('div');
        kelvinDiv.className = 'kelvin-option';
        kelvinDiv.innerHTML = `
          <input type="radio" class="kelvin_option" form='${form_id}' 
            name="properties[Kelvin]" id="kelvin-${kelvin.kelvin_name}"
            value="${kelvin.kelvin_title} (${kelvin.kelvin_name})" 
            ${index === 0 ? 'checked' : ''} />
          <label for="kelvin-${kelvin.kelvin_name}">
            <span class="color_code" style="background: ${kelvin.color};"></span>
            ${kelvin.kelvin_title} (${kelvin.kelvin_name})
          </label>`;

        kelvinDiv.querySelector('input').addEventListener('change', () => {
          kelvin_vb.innerHTML = `<div class="label_name">Kelvin</div> <span class="color_code" style="background: ${kelvin.color};"></span>
          <div class="option_name">${kelvin.kelvin_title} (${kelvin.kelvin_name})</div> `;
          kelvin_slected.innerHTML = `${kelvin.kelvin_title} (${kelvin.kelvin_name})`;
          filterOpticsOptions(kelvin.optics);
          document.querySelector('#sku_led_type').innerHTML = `-${kelvin.kelvin_title}`;
        });

        kelvinContainer.appendChild(kelvinDiv);
        const firstimg = kelvinContainer.querySelector('label .color_code');
        if (index === 0) {
          kelvin_vb.innerHTML = `<div class="label_name">Kelvin</div> <span class="color_code" style="background: ${firstimg.style.background};"></span><div class="option_name">${kelvinContainer.querySelector('label').textContent}</div>`;
          kelvin_slected.innerHTML = kelvinContainer.querySelector('label').textContent;
          filterOpticsOptions(kelvin.optics);
          document.querySelector('#sku_led_type').innerHTML = `-${kelvin.kelvin_title}`;
        }
      }
    });
  }

  // Filter and display optics options
  function filterOpticsOptions(opticsArray) {
    if (!Array.isArray(opticsArray)) return;

    const opticsContainer = document.getElementById('filtered-optics-options');
    opticsContainer.innerHTML = '';
    const optics_vb = document.querySelector('.optics_vb');
    optics_vb.innerHTML = '';
    const optics_slected = document.querySelector('.optics_slected');
    optics_slected.innerHTML = '';

    document.querySelector('.optics_main').classList.remove('none_h');
    opticsContainer.style.display = 'block';

    opticsArray.forEach((optic, index) => {
      const opticDiv = document.createElement('div');
      opticDiv.className = 'optic-option';
      opticDiv.innerHTML = `
        <input type="radio" class="optic_option" id="optic-${optic.name}" 
          form='${form_id}' name="properties[Optics]" value="${optic.name}" 
          ${index === 0 ? 'checked' : ''} />
        <label for="optic-${optic.name}">
          <img src="${optic.image}" alt="${optic.name}" width="100" height="100">
          ${optic.name}
        </label>`;

      opticDiv.querySelector('input').addEventListener('change', () => {
        optics_vb.innerHTML = `<div class="label_name">Optics</div> 
        <img src="${optic.image}" alt="${optic.name}" width="60"/> <div class="option_name">${optic.name}</div>`;
        optics_slected.innerHTML = optic.name;
        document.querySelector('#sku_optics').innerHTML = `-${optic.name}`;
      });

      opticsContainer.appendChild(opticDiv);

      const firstimg = opticsContainer.querySelector('label img');
      if (index === 0) {
        optics_vb.innerHTML = `<div class="label_name">Optics</div> <img src="${firstimg.src}" alt="${firstimg.alt}" width="60"/><div class="option_name">${firstimg.alt}</div>`;
        optics_slected.innerHTML = firstimg.alt;
        document.querySelector('#sku_optics').innerHTML = `-${optic.name}`;
      }
    });
  }

}
else if (template === 'mailbox') {
  function filterMailbox() {
    const checkedStyleInput = document.querySelector('.mount-style-main input:checked');
    document.querySelector(`.mount_slected`).innerHTML = checkedStyleInput.value;
    const visualizer_box = document.querySelector('.visualizer_box');
    const SKU_id_hh = document.querySelector('.SKU_id_hh');

    if (!checkedStyleInput) return;

    const selectedMountStyle = checkedStyleInput.value.trim().toLowerCase();
    const filteredPosts = variant_json.filter(variant =>
      variant.item_id?.trim().toLowerCase() === selectedMountStyle
    );

    // Define all option types in a structured way
    const optionTypes = [
      {
        name: 'post',
        containerId: 'filtered-posts',
        selectedClass: 'post_slected',
        propertyName: 'Post',
        cssClass: 'post_dynamic_'
      },
      {
        name: 'wrap',
        containerId: 'filtered-wraps',
        selectedClass: 'wrap_slected',
        propertyName: 'Wrap',
        cssClass: 'wrap_dynamic_'
      },
      {
        name: 'post_cap',
        containerId: 'filtered-post-caps',
        selectedClass: 'post_cap_slected',
        propertyName: 'Post Cap',
        cssClass: 'post_cap_dynamic_'
      },
      {
        name: 'sign_content',
        containerId: 'filtered-sign-colors',
        selectedClass: 'sign_color_slected',
        propertyName: 'Sign Color',
        cssClass: 'sign_color_dynamic_'
      },
      {
        name: 'sign_font',
        containerId: 'filtered-sign-fonts',
        selectedClass: 'sign_font_slected',
        propertyName: 'Sign Font',
        cssClass: 'sign_font_dynamic_'
      }
    ];

    // Reset containers and selected elements
    const containers = {};
    const selectedElements = {};
    const uniqueSets = {};

    optionTypes.forEach(type => {
      // Initialize containers
      containers[type.name] = document.getElementById(type.containerId);
      if (containers[type.name]) containers[type.name].innerHTML = '';

      // Initialize selected elements
      selectedElements[type.name] = document.querySelector(`.${type.selectedClass}`);
      if (selectedElements[type.name]) selectedElements[type.name].innerHTML = '';

      // Initialize unique sets
      uniqueSets[type.name] = new Set();
    });

    // Reset size visual badge
    const size_vb = document.querySelector('.product_slected');
    size_vb.innerHTML = '';
    if (match === 'item_id') {
      size_vb.innerHTML = `${filteredPosts[0].item_id}`;
      document.querySelector('.download_spec').href = filteredPosts[0].spec_sheet;
      // document.querySelector('#featured_image').src = filteredPosts[0].image || '#';
    }

    if (filteredPosts.length) {
      // Helper function to create an option element
      const createOptionElement = (type, item, variant) => {
        const element = document.createElement('div');
        element.className = `horizontal-view ${type.name}-${item.name.replace(/[^a-zA-Z0-9]/g, '_')}`;
        // element.className = `horizontal-view ${item.name.replace(/[^a-zA-Z0-9]/g, '_').split('___')[0].toLowerCase()}`;
        const id = `${type.name.replace('_', '-')}-${item.value}`;
        if(item.name.includes('Raised Cast')){
        element.classList.add('raised_cast');
        
        }
        element.innerHTML = `
          <input type='radio' class='${type.cssClass} ${type.name == "sign_content" ? "sign_content_input" : ""} ${item.name.includes("Raised Cast") ? "raised_cast_input" : ""}' id='${id}'
            data-mount-style='${variant.mount_style}' form='${form_id}'  
            name='properties[${type.propertyName}]' value='${item.name}' data-value="${item.value}"/>
          <label for='${id}'>
            <img src="${item.image || '#'}&width=${type.name === 'sign_font' ? '350' : '230'}" 
              alt="${item.build_box_name || item.name}"  width="${type.name === 'sign_font' ? '350' : '50'}px">
            ${type.name === 'sign_font' ? "" : item.name}
          </label>`;
        // Add event listener to update selected value when this input changes
        const input = element.querySelector('input');
        input.addEventListener('change', () => {
          if (selectedElements[type.name]) {
            const skuElement = SKU_id_hh.querySelector(`#sku_${[type.name]}`);
            if (skuElement) {
              skuElement.innerHTML = "-"+input.dataset.value;
            }
            selectedElements[type.name].innerHTML = input.value;
            document.querySelector(`.${type.selectedClass}`).innerHTML = input.value;
            const existingVisualizer = visualizer_box.querySelector(`.visualizer_${type.name}`);
            let visualizerElement;

            if (existingVisualizer) {
              visualizerElement = existingVisualizer;
            } else {
              visualizerElement = document.createElement('div');
              visualizerElement.classList.add(`visualizer_${type.name}`);
              visualizer_box.appendChild(visualizerElement);
            }

            visualizerElement.innerHTML = `<div class="label_name">${type.name.replace(/_/g, ' ')}</div>
             <img src="${item.image || '#'}&width=200" 
               alt="${item.build_box_name || item.name}" width="50px">
               <div class="option_name">${item.build_box_name || item.name}</div>`;
          }
        });

        return element;
      };

      // Process all variants
      filteredPosts.forEach(variant => {

        // Process each option type
        optionTypes.forEach(type => {
          if (variant[type.name] && Array.isArray(variant[type.name])) {
            variant[type.name].forEach(item => {
              // Use item value as unique identifier
              if (!uniqueSets[type.name].has(item.value)) {
                uniqueSets[type.name].add(item.value);

                // Create and add the element to container
                if (containers[type.name]) {
                  const element = createOptionElement(type, item, variant);
                  containers[type.name].appendChild(element);
                }
              }
            });
          }
        });
      });

      // Select first option for each type and update UI
      optionTypes.forEach(type => {
        const firstInput = containers[type.name]?.querySelector('input[type="radio"]');
        const firstimg = containers[type.name]?.querySelector('label img');
        if (firstInput && selectedElements[type.name]) {
          firstInput.checked = true;
          selectedElements[type.name].innerHTML = `${firstInput.value}`;
          // Initialize SKU value for first option
          if (SKU_id_hh && firstInput.dataset.value && type.name) {
            const skuItemId = SKU_id_hh.querySelector('#sku_item_id');
            const skuTypeName = SKU_id_hh.querySelector(`#sku_${type.name}`);
            if (skuItemId) skuItemId.innerHTML = checkedStyleInput.value;
            if (skuTypeName) skuTypeName.innerHTML = '-' + firstInput.dataset.value;
          }
          const existingVisualizer = visualizer_box.querySelector(`.visualizer_${type.name}`);
          let visualizerElement;

          if (existingVisualizer) {
            visualizerElement = existingVisualizer;
          } else {
            visualizerElement = document.createElement('div');
            visualizerElement.classList.add(`visualizer_${type.name}`);
            visualizer_box.appendChild(visualizerElement);
          }

          visualizerElement.innerHTML = `<div class="label_name">${type.name.replace(/_/g, ' ')}</div>
          ${firstimg ? `<img src="${firstimg.src || '#'}&width=200" 
              alt="${firstimg.alt || 'Image'}" width="50px">` : ''}
              <div class="option_name">${firstimg ? firstimg.alt : ''}</div>`;
          if (filteredPosts[0] && filteredPosts[0].spec_sheet) {
            document.querySelector('.download_spec').href = filteredPosts[0].spec_sheet;
          }
          document.querySelector('#featured_image').src = filteredPosts[0].image || '#';
          try {
            new DropdownManager();
          } catch (error) {
            console.warn('Error initializing DropdownManager:', error);
          }
          // Special case for post to update size_vb
          if (type.name === 'post' && firstInput) {
            size_vb.innerHTML = `${checkedStyleInput.value}`;
          }
          if (type.name === 'sign_content' && containers[type.name].children.length > 0) {
            document.querySelector('.sign_content-main').classList.remove('none_h');
            const firstSignContentInput = document.querySelector('.sign_content-main input[type="radio"]');
              if (firstSignContentInput) {
                firstSignContentInput.checked = true;
              }
          }
        }else{
          try {
            new DropdownManager();
          } catch (error) {
            console.warn('Error initializing DropdownManager:', error);
          }

          const skuItemId = SKU_id_hh.querySelector('#sku_item_id');
          if (skuItemId) skuItemId.innerHTML = checkedStyleInput.value;
        }

        // Update visibility of container
        if (containers[type.name] && containers[type.name].parentElement) {
          if (containers[type.name].children.length <= 0) {
            containers[type.name].parentElement.classList.add("none_h");
            updateSkuElement(type.name, 'hide');
            // Also hide the corresponding visualizer element
            const relatedVisualizer = visualizer_box.querySelector(`.visualizer_${type.name}`);
            if (relatedVisualizer) {
              relatedVisualizer.style.display = 'none';
            }
            if (type.name === 'sign_content') {
              document.querySelector('.sign_content-main').classList.add('none_h');
              const firstSignContentInput = document.querySelector('.sign_content-main input[type="radio"]');
              if (firstSignContentInput) {
                firstSignContentInput.checked = false;
              }
            }
          } else {
            containers[type.name].parentElement.classList.remove("none_h");
            updateSkuElement(type.name, 'show');
            // Show the corresponding visualizer element
            const relatedVisualizer = visualizer_box.querySelector(`.visualizer_${type.name}`);
            if (relatedVisualizer) {
              relatedVisualizer.style.display = '';
            }
          }
        }
      });
    } else {
      // Set empty state messages
      optionTypes.forEach(type => {
        if (containers[type.name]) {
          containers[type.name].innerHTML = `<p>No ${type.propertyName.toLowerCase()} found.</p>`;
        }
      });
    }

    handleSignFontVisibility();
  }

  // Handle sign content radio buttons
  const signContentRadios = document.querySelectorAll('.sign_content-main input[type="radio"]');
  signContentRadios.forEach(radio => {
    radio.addEventListener('change', (event) => {
      const signColorSection = document.querySelector('#filtered-sign-colors').closest('.product_variants');
      const signFontSection = document.querySelector('#filtered-sign-fonts').closest('.product_variants');
      const visualizer_box = document.querySelector('.visualizer_box');
      const signColorVisualizer = visualizer_box?.querySelector('.visualizer_sign_content');
      const signFontVisualizer = visualizer_box?.querySelector('.visualizer_sign_font');
      const SKU_id_hh = document.querySelector('.SKU_id_hh');
      SKU_id_hh.querySelector(`#sku_sign_content`).innerHTML = "";
      SKU_id_hh.querySelector(`#sku_sign_font`).innerHTML = "";
      
      if (event.target.id === 'sign-contents-yes' && event.target.checked) {
        SKU_id_hh.querySelector(`#sku_sign_content`).innerHTML = "-"+event.target.value;
        const filteredSignFonts = document.getElementById('filtered-sign-fonts');
        if (filteredSignFonts && filteredSignFonts.children.length > 0) {
          signFontSection?.classList.remove('none_h');
          SKU_id_hh.querySelector(`#sku_sign_font`).innerHTML = "-"+event.target.value;
        } else {
          signFontSection?.classList.add('none_h');
          SKU_id_hh.querySelector(`#sku_sign_font`).innerHTML = "";
        }
        signColorSection?.classList.remove('none_h');
        // signFontSection?.classList.remove('none_h');
        // Check first radio input in both sections
        const firstColorInput = signColorSection?.querySelector('input[type="radio"]');
        const firstFontInput = signFontSection?.querySelector('input[type="radio"]');
        if (firstColorInput) {
          firstColorInput.checked = true;
          // Trigger change event to update visualizer
          firstColorInput.dispatchEvent(new Event('change'));
        }
        if (firstFontInput) {
          firstFontInput.checked = true;
          // Trigger change event to update visualizer
          firstFontInput.dispatchEvent(new Event('change'));
        }
        // Handle sign font visibility
      } else {
        signColorSection?.classList.add('none_h');
        signFontSection?.classList.add('none_h');
        // Uncheck all radio inputs in sign colors and fonts sections
        signColorSection?.querySelectorAll('input[type="radio"]').forEach(input => input.checked = false);
        signFontSection?.querySelectorAll('input[type="radio"]').forEach(input => input.checked = false);
        // Remove visualizer elements
        signColorVisualizer?.remove();
        signFontVisualizer?.remove();
        // Handle sign font visibility
      }
    });
  });

  // Function to handle sign font visibility based on current state
  function handleSignFontVisibility() {
    const checkedSignContentInput = document.querySelector('.sign_content_input:checked');
    const checkedRaisedCastInput = document.querySelector('.raised_cast_input:checked');
    // Get all sign font elements
    const signFontElements = document.querySelectorAll('[class*="sign_font-"]');
    console.log(checkedSignContentInput, "checkedSignContentInput");
    if (checkedSignContentInput && checkedRaisedCastInput) {
      console.log("both sign_content_input and raised_cast_input are checked");
      // If both sign_content_input and raised_cast_input are checked
      const clarendonElement = document.querySelector('.sign_font-Clarendon');
      
      if (clarendonElement) {
        // If Clarendon is present, show only Clarendon
        signFontElements.forEach(element => {
          if (element.classList.contains('sign_font-Clarendon')) {
            element.style.display = 'block';
            const signFontInput = element.querySelector('input[type="radio"]');
            if (signFontInput) {
              signFontInput.checked = true;
              signFontInput.dispatchEvent(new Event('change'));
            }
          } else {
            element.style.display = 'none';
          }
        });
      } else {
        // If Clarendon is not present, show all available fonts
        signFontElements.forEach(element => {
          element.style.display = 'block';
        });
      }
    } else if (checkedSignContentInput) {
      console.log("sign_content_input is checked");
      // If only sign_content_input is checked
      signFontElements.forEach(element => {
        element.style.display = 'block';
      });
    } else {
      // If neither is checked, show all sign font elements
      signFontElements.forEach(element => {
        element.style.display = 'block';
      });
    }
  }

  // Also add event listeners for raised_cast_input changes
  document.addEventListener('change', (event) => {
    console.log(event.target, "event.target");
    handleSignFontVisibility();
  });

  // Call the function on page load to handle initial state
}
else if (template === 'pathway') {
  function filterLineVoltage() {
    const checkedStyleInput = document.querySelector('.mount-style-main input:checked');
    document.querySelector(`.mount_slected`).innerHTML = checkedStyleInput.value;
    const visualizer_box = document.querySelector('.visualizer_box');
    const SKU_id_hh = document.querySelector('.SKU_id_hh');
    const Specs = document.querySelector('#Specs');
    Specs.innerHTML = '';

    if (!checkedStyleInput) return;

    const selectedMountStyle = checkedStyleInput.value.trim().toLowerCase();
    const filteredPosts = variant_json.filter(variant =>
      variant.item_id?.trim().toLowerCase() === selectedMountStyle
    );
    const panelElement = document.querySelector('#panels');
    panelElement.innerHTML = '';
    filteredPosts.forEach(variant => {
      if (variant.panel?.length) {
        document.querySelector("#sku_Panel").classList.remove("none_h")
        document.querySelector(".custom-dropdown[data-dropdown='Panel']").closest(".product_step").classList.remove("none_h")
        const panel_vb = document.querySelector('.Panel_vb');
        panel_vb.innerHTML = "";
        variant.panel.forEach((panel, index) => {
          if (panel) {
            const li = document.createElement('li');
            li.setAttribute('data-value', panel.value);
            li.innerHTML = `<label><input type="radio" form='${form_id}' ${index === 0 ? 'checked' : ''} 
            name='properties[${panelElement.dataset.dropdown}]' value="${panel.name}"  data-value="${panel.value}">
            <img src="${panel.image || '#'}&width=100" 
                alt="${panel.name || 'Image'}" width='100'> ${panel.name}</label>`;
            panelElement.appendChild(li);
            if (index == 0) {
              panel_vb.innerHTML = `<div class="label_name">Panel</div> <img src="${panel.image || '#'}&width=70" 
                alt="${panel.name || 'Image'}" width='70px'><div class="option_name"> ${panel.name}</div>`;
            }
          }
        });
      } else {
        document.querySelector("#sku_Panel").classList.add("none_h");
        document.querySelector("#sku_Panel").innerHTML = "";
        document.querySelector(".custom-dropdown[data-dropdown='Panel']").closest(".product_step").classList.add("none_h")
      }
    });
    new DropdownManager();
    // Define all option types in a structured way
    const optionTypes = [
      {
        name: 'stem',
        containerId: 'filtered-stems',
        selectedClass: 'stem_slected',
        propertyName: 'Post',
        cssClass: 'stem_dynamic_'
      },
      {
        name: 'lamping',
        containerId: 'filtered-lampings',
        selectedClass: 'lamping_slected',
        propertyName: 'Lamping',
        cssClass: 'lamping_type_dynamic_'
      },
      {
        name: 'ground_mounting',
        containerId: 'filtered-ground_mountings',
        selectedClass: 'ground_mounting_slected',
        propertyName: 'Ground_mounting',
        cssClass: 'ground_mounting_dynamic_'
      }
    ];

    // Reset containers and selected elements
    const containers = {};
    const selectedElements = {};
    const uniqueSets = {};

    optionTypes.forEach(type => {
      // Initialize containers
      containers[type.name] = document.getElementById(type.containerId);
      if (containers[type.name]) containers[type.name].innerHTML = '';

      // Initialize selected elements
      selectedElements[type.name] = document.querySelector(`.${type.selectedClass}`);
      if (selectedElements[type.name]) selectedElements[type.name].innerHTML = '';

      // Initialize unique sets
      uniqueSets[type.name] = new Set();
    });

    // Reset size visual badge
    const size_vb = document.querySelector('.product_slected');

    size_vb.innerHTML = '';
    if (match === 'item_id') {
      size_vb.innerHTML = `${filteredPosts[0].item_id}`;
      document.querySelector('.download_spec').href = filteredPosts[0].spec_sheet;
      // document.querySelector('#featured_image').src = filteredPosts[0].image || '#';
    }

    if (filteredPosts.length) {
      // Helper function to create an option element
      const createOptionElement = (type, item, variant) => {
        const element = document.createElement('div');
        element.className = 'horizontal-view';
        const id = `${type.name.replace('_', '-')}-${item.value}`;

        element.innerHTML = `
          <input type='radio' class='${type.cssClass}' id='${id}'
            data-mount-style='${variant.mount_style}' form='${form_id}'  
            name='properties[${type.propertyName}]' value='${item.name}'  data-value="${item.value}" />
          <label for='${id}'>
            <img src="${item.image}&width=350" alt="${item.build_box_name || item.name}" width="350px">
              ${item.name}
          </label>`;
        // Add event listener to update selected value when this input changes
        const input = element.querySelector('input');
        input.addEventListener('change', () => {
          if (selectedElements[type.name]) {
            const skuElement = SKU_id_hh.querySelector(`#sku_${[type.name]}`);
            const specs = ['height', 'width_dia', 'length', 'extension', 'top_to_outlet', 'chain', 'canopy']
            .reduce((acc, key) => {
              return variant[key] ? acc + `<span><strong>${key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}:</strong> ${variant[key]}</span>` : acc; 
            }, '');

            Specs.innerHTML = specs;
            if (skuElement) {
              skuElement.innerHTML = "-"+input.dataset.value;
            }
            selectedElements[type.name].innerHTML = input.value;
            document.querySelector(`.${type.selectedClass}`).innerHTML = input.value;
            const existingVisualizer = visualizer_box.querySelector(`.visualizer_${type.name}`);
            let visualizerElement;

            if (existingVisualizer) {
              visualizerElement = existingVisualizer;
            } else {
              visualizerElement = document.createElement('div');
              visualizerElement.classList.add(`visualizer_${type.name}`);
              visualizer_box.appendChild(visualizerElement);
            }

            visualizerElement.innerHTML = `<div class="label_name">${type.name.replace(/_/g, ' ')}</div>
             ${item.image ? `<img src="${item.image}&width=200" alt="${item.build_box_name || item.name}" width="50px">` : ''}
              <div class="option_name">${item.build_box_name || item.name}</div>`;
          }
        });

        return element;
      };
      // Process all variants
      filteredPosts.forEach(variant => {

        // Process each option type
        optionTypes.forEach(type => {
          if (variant[type.name] && Array.isArray(variant[type.name])) {
            variant[type.name].forEach(item => {
              // Use item value as unique identifier
              if (!uniqueSets[type.name].has(item.value)) {
                uniqueSets[type.name].add(item.value);

                // Create and add the element to container
                if (containers[type.name]) {
                  const element = createOptionElement(type, item, variant);
                  containers[type.name].appendChild(element);
                }
              }
            });
          }
        });
      });

      // Select first option for each type and update UI
      optionTypes.forEach(type => {
        const variant = filteredPosts[0];
        const firstInput = containers[type.name]?.querySelector('input[type="radio"]');
        const firstimg = containers[type.name]?.querySelector('label img');
        if (firstInput && selectedElements[type.name]) {
          firstInput.checked = true;
          selectedElements[type.name].innerHTML = `${firstInput.value}`;
          // Initialize SKU value for first option
          if (SKU_id_hh && firstInput.dataset.value && type.name) {
            const skuItemId = SKU_id_hh.querySelector('#sku_item_id');
            const skuTypeName = SKU_id_hh.querySelector(`#sku_${type.name}`);
            if (skuItemId) skuItemId.innerHTML = checkedStyleInput.value;
            if (skuTypeName) skuTypeName.innerHTML = '-' + firstInput.dataset.value;
          }

          const specs = ['height', 'width_dia', 'length', 'extension', 'top_to_outlet', 'chain', 'canopy']
          .reduce((acc, key) => {
            return variant[key] ? acc + `<span><strong>${key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}:</strong> ${variant[key]}</span>` : acc; 
          }, '');

          Specs.innerHTML = specs;
          const existingVisualizer = visualizer_box.querySelector(`.visualizer_${type.name}`);
          let visualizerElement;

          if (existingVisualizer) {
            visualizerElement = existingVisualizer;
          } else {
            visualizerElement = document.createElement('div');
            visualizerElement.classList.add(`visualizer_${type.name}`);
            visualizer_box.appendChild(visualizerElement);
          }

          visualizerElement.innerHTML = `<div class="label_name">${type.name.replace(/_/g, ' ')}</div>
          ${firstimg ? `<img src="${firstimg.src || '#'}&width=200" 
              alt="${firstimg.alt || 'Image'}" width="50px">` : ''}
              <div class="option_name">${firstimg ? firstimg.alt : ''}</div>`;
          if (filteredPosts[0] && filteredPosts[0].spec_sheet) {
            document.querySelector('.download_spec').href = filteredPosts[0].spec_sheet;
          }
          document.querySelector('#featured_image').src = filteredPosts[0].image || '#';
          // Special case for post to update size_vb
          if (type.name === 'stem' && firstInput) {
            size_vb.innerHTML = `${filteredPosts[0].item_id}`;
          }
          if (type.name === 'sign_content' && containers[type.name].children.length > 0) {
            document.querySelector('.sign_content-main').classList.remove('none_h');
            document.querySelector('#sku_sign_content').classList.remove('none_h');
            document.querySelector('#sku_sign_font').classList.remove('none_h');
            const firstSignContentInput = document.querySelector('.sign_content-main input[type="radio"]');
              if (firstSignContentInput) {
                firstSignContentInput.checked = true;
              }
          }
        }

        // Update visibility of container
        if (containers[type.name] && containers[type.name].parentElement) {
          if (containers[type.name].children.length <= 0) {
            containers[type.name].parentElement.classList.add("none_h");
            updateSkuElement(type.name, 'hide');
            // Also hide the corresponding visualizer element
            const relatedVisualizer = visualizer_box.querySelector(`.visualizer_${type.name}`);
            if (relatedVisualizer) {
              relatedVisualizer.style.display = 'none';
            }
            if (type.name === 'sign_content') {
              document.querySelector('.sign_content-main').classList.add('none_h');
              const firstSignContentInput = document.querySelector('.sign_content-main input[type="radio"]');
              if (firstSignContentInput) {
                firstSignContentInput.checked = false;
              }
              updateSkuElement('sign_content', 'hide');
              updateSkuElement('sign_font', 'hide');
            }
          } else {
            containers[type.name].parentElement.classList.remove("none_h");
            updateSkuElement(type.name, 'show');
            // Show the corresponding visualizer element
            const relatedVisualizer = visualizer_box.querySelector(`.visualizer_${type.name}`);
            if (relatedVisualizer) {
              relatedVisualizer.style.display = '';
            }
          }
        }
      });
    } else {
      // Set empty state messages
      optionTypes.forEach(type => {
        if (containers[type.name]) {
          containers[type.name].innerHTML = `<p>No ${type.propertyName.toLowerCase()} found.</p>`;
        }
      });
    }

  }

  // Handle sign content radio buttons
  const signContentRadios = document.querySelectorAll('.sign_content-main input[type="radio"]');
  signContentRadios.forEach(radio => {
    radio.addEventListener('change', (event) => {
      const signColorSection = document.querySelector('#filtered-sign-colors').closest('.product_variants');
      const signFontSection = document.querySelector('#filtered-sign-fonts').closest('.product_variants');
      const visualizer_box = document.querySelector('.visualizer_box');
      const signColorVisualizer = visualizer_box?.querySelector('.visualizer_sign_content');
      const signFontVisualizer = visualizer_box?.querySelector('.visualizer_sign_font');
      const SKU_id_hh = document.querySelector('.SKU_id_hh');
      SKU_id_hh.querySelector(`#sku_sign_content`).innerHTML = "";
      SKU_id_hh.querySelector(`#sku_sign_font`).innerHTML = "";
      if (event.target.id === 'sign-contents-yes' && event.target.checked) {
        SKU_id_hh.querySelector(`#sku_sign_content`).innerHTML = "-"+event.target.value;
        const filteredSignFonts = document.getElementById('filtered-sign-fonts');
        if (filteredSignFonts && filteredSignFonts.children.length > 0) {
          signFontSection?.classList.remove('none_h');
          SKU_id_hh.querySelector(`#sku_sign_font`).innerHTML = "-"+event.target.value;
        } else {
          signFontSection?.classList.add('none_h');
          SKU_id_hh.querySelector(`#sku_sign_font`).innerHTML = "";
        }
        signColorSection?.classList.remove('none_h');
        // signFontSection?.classList.remove('none_h');

        // Check first radio input in both sections
        const firstColorInput = signColorSection?.querySelector('input[type="radio"]');
        const firstFontInput = signFontSection?.querySelector('input[type="radio"]');
        if (firstColorInput) {
          firstColorInput.checked = true;
          // Trigger change event to update visualizer
          firstColorInput.dispatchEvent(new Event('change'));
        }
        if (firstFontInput) {
          firstFontInput.checked = true;
          // Trigger change event to update visualizer
          firstFontInput.dispatchEvent(new Event('change'));
        }
      } else {
        signColorSection?.classList.add('none_h');
        signFontSection?.classList.add('none_h');
        // Uncheck all radio inputs in sign colors and fonts sections
        signColorSection?.querySelectorAll('input[type="radio"]').forEach(input => input.checked = false);
        signFontSection?.querySelectorAll('input[type="radio"]').forEach(input => input.checked = false);

        // Remove visualizer elements
        signColorVisualizer?.remove();
        signFontVisualizer?.remove();
      }
    });
  });
}
else if (template === 'post') {
  function filterPosts() {
    const checkedStyleInput = document.querySelector('.mount-style-main input:checked');
    document.querySelector(`.mount_slected`).innerHTML = checkedStyleInput.value;
    const visualizer_box = document.querySelector('.visualizer_box');
    const SKU_id_hh = document.querySelector('.SKU_id_hh');

    if (!checkedStyleInput) return;

    const selectedMountStyle = checkedStyleInput.value.trim().toLowerCase();
    const filteredPosts = variant_json.filter(variant =>
      variant.model?.trim().toLowerCase() === selectedMountStyle
    );

    // Update the featured image immediately when mount style changes
    if (filteredPosts.length > 0 && filteredPosts[0].image) {
      const featuredImage = document.querySelector('#featured_image');
      if (featuredImage) {
        featuredImage.src = filteredPosts[0].image;
      }

      // Also update spec sheet if available
      if (filteredPosts[0].spec_sheet) {
        const specSheet = document.querySelector('.download_spec');
        if (specSheet) {
          specSheet.href = filteredPosts[0].spec_sheet;
        }
      }
    }

    // Define all option types in a structured way
    const optionTypes = [
      {
        name: 'height',
        containerId: 'filtered-heights',
        selectedClass: 'height_slected',
        propertyName: 'Height',
        cssClass: 'height_dynamic_'
      },
      {
        name: 'photoeye',
        containerId: 'filtered-photoeye',
        selectedClass: 'photoeye_slected',
        propertyName: 'Photoeye',
        cssClass: 'photoeye_dynamic_'
      },
      {
        name: 'convenience_outlet',
        containerId: 'filtered-convenience_outlet',
        selectedClass: 'convenience_outlet_slected',
        propertyName: 'Convenience Outlet',
        cssClass: 'convenience_outlet_dynamic_'
      },
      {
        name: 'tenon',
        containerId: 'filtered-tenon',
        selectedClass: 'tenon_slected',
        propertyName: 'Tenon',
        cssClass: 'tenon_dynamic_'
      }
    ];

    // Reset containers and selected elements
    const containers = {};
    const selectedElements = {};
    const uniqueSets = {};

    optionTypes.forEach(type => {
      // Initialize containers
      containers[type.name] = document.getElementById(type.containerId);
      if (containers[type.name]) containers[type.name].innerHTML = '';

      // Initialize selected elements
      selectedElements[type.name] = document.querySelector(`.${type.selectedClass}`);
      if (selectedElements[type.name]) selectedElements[type.name].innerHTML = '';

      // Initialize unique sets
      uniqueSets[type.name] = new Set();
    });

    // Reset size visual badge
    const size_vb = document.querySelector('.product_slected');
    size_vb.innerHTML = '';


    if (filteredPosts.length) {
      // Helper function to create an option element
      const createOptionElement = (type, item, variant) => {
        const element = document.createElement('div');
        element.className = `horizontal-view  ${type.propertyName == "Height" ? 'no_image_label' : ''}`;
        const id = `${type.name.replace('_', '-')}-${item.value}`;

        element.innerHTML = `
          <input type='radio' class='${type.cssClass}' id='${id}'
            data-mount-style='${variant.mount_style}' form='${form_id}'  
            name='properties[${type.propertyName}]' value='${item.name}' data-value="${item.value}"/>
          <label for='${id}'>
            <img src="${item.image || '#'}&width=${type.name === 'sign_font' ? '350' : '230'}" 
              alt="${item.build_box_name || item.name}"  width="${type.name === 'sign_font' ? '350' : '50'}px">
            ${type.name === 'sign_font' ? "" : item.name}
          </label>`;
        // Add event listener to update selected value when this input changes
        const input = element.querySelector('input');
        input.addEventListener('change', () => {
          if (selectedElements[type.name]) {
            selectedElements[type.name].innerHTML = input.value;
            const skuElement = SKU_id_hh.querySelector(`#sku_${[type.name]}`);
            if (skuElement) {
              skuElement.innerHTML = "-"+input.dataset.value;
            }
            document.querySelector(`.${type.selectedClass}`).innerHTML = input.value;
            const existingVisualizer = visualizer_box.querySelector(`.visualizer_${type.name}`);
            let visualizerElement;

            if (existingVisualizer) {
              visualizerElement = existingVisualizer;
            } else {
              visualizerElement = document.createElement('div');
              visualizerElement.classList.add(`visualizer_${type.name}`);
              visualizer_box.appendChild(visualizerElement);
            }

            visualizerElement.innerHTML = `<div class="label_name">${type.name.replace(/_/g, ' ')}</div>
             <img src="${item.image || '#'}&width=200" 
               alt="${item.build_box_name || item.name}" width="50px">
               <div class="option_name">${item.build_box_name || item.name}</div>`;
          }
        });

        return element;
      };

      // Process all variants
      filteredPosts.forEach(variant => {

        // Process each option type
        optionTypes.forEach(type => {
          if (variant[type.name] && Array.isArray(variant[type.name])) {
            variant[type.name].forEach(item => {
              // Use item value as unique identifier
              if (!uniqueSets[type.name].has(item.value)) {
                uniqueSets[type.name].add(item.value);

                // Create and add the element to container
                if (containers[type.name]) {
                  const element = createOptionElement(type, item, variant);
                  containers[type.name].appendChild(element);
                }
              }
            });
          }
        });
      });

      // Select first option for each type and update UI
      optionTypes.forEach(type => {
        const firstInput = containers[type.name]?.querySelector('input[type="radio"]');
        const firstimg = containers[type.name]?.querySelector('label img');
        if (firstInput && selectedElements[type.name]) {
          firstInput.checked = true;
          selectedElements[type.name].innerHTML = `${firstInput.value}`;

          // Initialize SKU value for first option
          if (SKU_id_hh && firstInput.dataset.value && type.name) {
            const skuItemId = SKU_id_hh.querySelector('#sku_item_id');
            const skuTypeName = SKU_id_hh.querySelector(`#sku_${type.name}`);
            if (skuItemId) skuItemId.innerHTML = checkedStyleInput.value;
            if (skuTypeName) skuTypeName.innerHTML = '-' + firstInput.dataset.value;
          }
          
          const existingVisualizer = visualizer_box.querySelector(`.visualizer_${type.name}`);
          let visualizerElement;

          if (existingVisualizer) {
            visualizerElement = existingVisualizer;
          } else {
            visualizerElement = document.createElement('div');
            visualizerElement.classList.add(`visualizer_${type.name}`);
            visualizer_box.appendChild(visualizerElement);
          }

          visualizerElement.innerHTML = `<div class="label_name">${type.name.replace(/_/g, ' ')}</div>
          ${firstimg ? `<img src="${firstimg.src || '#'}&width=200" 
              alt="${firstimg.alt || 'Image'}" width="50px">` : ''}
              <div class="option_name">${firstimg ? firstimg.alt : ''}</div>`;
          if (filteredPosts[0] && filteredPosts[0].spec_sheet) {
            document.querySelector('.download_spec').href = filteredPosts[0].spec_sheet;
          }
          // Remove duplicate image update to avoid overwriting
          // document.querySelector('#featured_image').src = filteredPosts[0].image || '#';
          new DropdownManager();
          // Special case for post to update size_vb
          if (type.name === 'height' && firstInput) {
            size_vb.innerHTML = `${checkedStyleInput.dataset.itemid}`;
          }
          if (type.name === 'sign_content' && containers[type.name].children.length > 0) {
            document.querySelector('.sign_content-main').classList.remove('none_h');
            const firstSignContentInput = document.querySelector('.sign_content-main input[type="radio"]');
              if (firstSignContentInput) {
                firstSignContentInput.checked = true;
              }
          }
        }

        // Update visibility of container
        if (containers[type.name] && containers[type.name].parentElement) {
          if (containers[type.name].children.length <= 0) {
            containers[type.name].parentElement.classList.add("none_h");
            updateSkuElement(type.name, 'hide');
            // Also hide the corresponding visualizer element
            const relatedVisualizer = visualizer_box.querySelector(`.visualizer_${type.name}`);
            if (relatedVisualizer) {
              relatedVisualizer.style.display = 'none';
            }
            if (type.name === 'sign_content') {
              document.querySelector('.sign_content-main').classList.add('none_h');
              const firstSignContentInput = document.querySelector('.sign_content-main input[type="radio"]');
              if (firstSignContentInput) {
                firstSignContentInput.checked = false;
              }
            }
          } else {
            containers[type.name].parentElement.classList.remove("none_h");
            updateSkuElement(type.name, 'show');
            // Show the corresponding visualizer element
            const relatedVisualizer = visualizer_box.querySelector(`.visualizer_${type.name}`);
            if (relatedVisualizer) {
              relatedVisualizer.style.display = '';
            }
          }
        }
      });
    } else {
      // Set empty state messages
      optionTypes.forEach(type => {
        if (containers[type.name]) {
          containers[type.name].innerHTML = `<p>No ${type.propertyName.toLowerCase()} found.</p>`;
        }
      });
    }

  }

  // Handle sign content radio buttons
  const signContentRadios = document.querySelectorAll('.sign_content-main input[type="radio"]');
  signContentRadios.forEach(radio => {
    radio.addEventListener('change', (event) => {
      const signColorSection = document.querySelector('#filtered-sign-colors').closest('.product_variants');
      const signFontSection = document.querySelector('#filtered-sign-fonts').closest('.product_variants');
      const visualizer_box = document.querySelector('.visualizer_box');
      const signColorVisualizer = visualizer_box?.querySelector('.visualizer_sign_content');
      const signFontVisualizer = visualizer_box?.querySelector('.visualizer_sign_font');
      const SKU_id_hh = document.querySelector('.SKU_id_hh');
      SKU_id_hh.querySelector(`#sku_sign_content`).innerHTML = "";
      SKU_id_hh.querySelector(`#sku_sign_font`).innerHTML = "";
      if (event.target.id === 'sign-contents-yes' && event.target.checked) {
        SKU_id_hh.querySelector(`#sku_sign_content`).innerHTML = "-"+event.target.value;
        const filteredSignFonts = document.getElementById('filtered-sign-fonts');
        if (filteredSignFonts && filteredSignFonts.children.length > 0) {
          signFontSection?.classList.remove('none_h');
          SKU_id_hh.querySelector(`#sku_sign_font`).innerHTML = "-"+event.target.value;
        } else {
          signFontSection?.classList.add('none_h');
          SKU_id_hh.querySelector(`#sku_sign_font`).innerHTML = "";
        }
        signColorSection?.classList.remove('none_h');
        // signFontSection?.classList.remove('none_h');

        // Check first radio input in both sections
        const firstColorInput = signColorSection?.querySelector('input[type="radio"]');
        const firstFontInput = signFontSection?.querySelector('input[type="radio"]');
        if (firstColorInput) {
          firstColorInput.checked = true;
          // Trigger change event to update visualizer
          firstColorInput.dispatchEvent(new Event('change'));
        }
        if (firstFontInput) {
          firstFontInput.checked = true;
          // Trigger change event to update visualizer
          firstFontInput.dispatchEvent(new Event('change'));
        }
      } else {
        signColorSection?.classList.add('none_h');
        signFontSection?.classList.add('none_h');
        // Uncheck all radio inputs in sign colors and fonts sections
        signColorSection?.querySelectorAll('input[type="radio"]').forEach(input => input.checked = false);
        signFontSection?.querySelectorAll('input[type="radio"]').forEach(input => input.checked = false);

        // Remove visualizer elements
        signColorVisualizer?.remove();
        signFontVisualizer?.remove();
      }
    });
  });
}

// Initialize event listeners
document.addEventListener('DOMContentLoaded', () => {
  // Handle product form submission
  const productDummy = document.querySelectorAll('.product_form__submit_dummy');
  if (productDummy) {
    productDummy.forEach(button => {
      button.addEventListener('click', () => {
        const skuText = document.querySelector('.SKU_id_hh').textContent.trim();
        const inputField = document.getElementById('product_form_id_input');
        const cartButton = document.querySelector('.product-form__submit');

        if (inputField && skuText) {
          inputField.value = skuText.replace(/Product Code:\s*/, '').replace(/\s+/g, '');
        }
        cartButton?.click();
      });
    });
  }

  // Initialize mount style and size filters
  const mountStyleContainer = document.querySelector('.mount-style-main');
  if (show === 'mount_style') {
    mountStyleContainer?.addEventListener('change', filterSizes);
    const sizeContainer = document.getElementById('filtered-sizes');
    sizeContainer?.addEventListener('change', filterVariantOptions);
  }
  else if (template === 'mailbox') {
    mountStyleContainer?.addEventListener('change', filterMailbox);
  }
  else if (template === 'post') {
    mountStyleContainer?.addEventListener('change', filterPosts);
  }
  else if (template === 'pathway') {
    mountStyleContainer?.addEventListener('change', filterLineVoltage);
  }

  // Handle "Other" input in contact form
  const formContainer = document.querySelector('.other-div-main');

  const addOtherInput = () => {
    if (!document.querySelector('#ContactForm-Other')) {
      const input = document.createElement('input');
      Object.assign(input, {
        type: 'text',
        id: 'ContactForm-Other',
        className: 'field__input',
        name: 'contact[Who are you]',
        placeholder: 'Other',
        value: ''
      });
      formContainer.appendChild(input);
      formContainer.classList.add('field');
    }
  };

  const removeOtherInput = () => {
    const input = document.querySelector('#ContactForm-Other');
    if (input) {
      input.remove();
      formContainer.classList.remove('field');
    }
  };

  document.querySelectorAll('input[name="contact[Who are you]"]')
    .forEach(radio => {
      radio.addEventListener('change', (event) => {
        event.target.classList.contains('other_who') ?
          addOtherInput() : removeOtherInput();
      });
    });
});

function Copy() {
  navigator.clipboard.writeText(window.location.href);
}
const popupBtn = document.getElementById("popupBtn_hh");
const overlay = document.getElementById("overlay_hh");
const popup = document.getElementById("popup_hh");
const closePopup = document.getElementById("closePopup_hh");

// Show the popup and overlay
popupBtn?.addEventListener("click", () => {
  overlay.style.display = "block";
  popup.style.display = "block";
});

// Hide the popup and overlay
closePopup?.addEventListener("click", () => {
  overlay.style.display = "none";
  popup.style.display = "none";
});

// Hide the popup if overlay is clicked
overlay?.addEventListener("click", () => {
  overlay.style.display = "none";
  popup.style.display = "none";
});

// Finish and panel slideout functionality


// // Initialize dropdown manager
// 

